class NSSVideo extends HTMLElement {
  constructor() {
    super();

    this.debug = false;

    this.els = {
      videos: this.querySelectorAll(`video`),
    };
  }

  connectedCallback() {
    if (this.debug) console.log(`[NSS][Video] Connected.`);

    this.addEventListener(`click`, this.handleClick.bind(this));

    this.els.videos.forEach((videoEl) => {
      videoEl.addEventListener(`play`, () => this.setAttribute(`nss-video-playing`, true));
      videoEl.addEventListener(`pause`, () => this.setAttribute(`nss-video-playing`, false));
      videoEl.addEventListener(`ended`, () => this.setAttribute(`nss-video-playing`, false));
    });
  }

  handleClick(e) {
    if (this.debug) console.log(`[NSS][Video] Click!`);

    const isPlaying = [...this.els.videos].some((videoEl) => !videoEl.paused);
    if (this.debug) console.log(`[NSS][Video] isPlaying:`, isPlaying);

    if (isPlaying) {
      this.els.videos.forEach((videoEl) => videoEl.pause());
    } else {
      this.els.videos.forEach((videoEl) => {
        // play() rejects when the browser blocks it; swallow so one blocked video does
        // not throw, and let the `play` event be what flips the attribute.
        const played = videoEl.play();
        if (played && played.catch) played.catch(() => {});
      });
    }
  }
}

let elementName = `nss-video`;
if (typeof customElements.get(elementName) === `undefined`) {
  customElements.define(elementName, NSSVideo);
} else {
  console.warn(`[NSS] Element '${elementName}' already defined.`);
}
